import { useSelector } from "react-redux";
import { RootState } from "app/store";
import { useScale } from "common/utils";
import { UserAvatar, PlanBadge } from "common/elements";
import { usePlan } from "features/subscription";

interface HeaderProps {
  onMenuClick: () => void;
}

export const Header = ({ onMenuClick }: HeaderProps) => {
  const plan = usePlan();
  const { width, scale } = useScale();
  const parent = useSelector((state: RootState) => state.user.parent);

  return (
    <div style={{ height: 90 * scale }} className="flex-col-el flex-center shrink-0">
      <header
        style={{ transform: `scale(${scale})`, width: width / scale }}
        className="flex-row-el h-[90px] items-center px-6 py-4 border-b border-outline bg-white"
      >
        {/* Hamburger menu button */}
        {/* Hamburger menu button */}
        <button
          className="flex-row-el items-center justify-center w-[48px] h-[48px] bg-gray2-30 rounded-lg text-textcolor-black cursor-pointer border-none hover:bg-gray2-40 transition-all mr-4 shrink-0"
          onClick={onMenuClick}
        >
          <span className="material-symbols-outlined text-[28px]">menu</span>
        </button>

        {/* User info */}
        <div className="flex-row-el items-center gap-4 flex-1 min-w-0">
          <div className="shrink-0">
            <UserAvatar size={72} icon={parent?.icon} />
          </div>
          <span className="text-[30px] text-textcolor-black truncate">
            {parent?.display_name || "-"}
          </span>
          <div className="shrink-0">
            <PlanBadge plan={plan} size="small" forParent />
          </div>
          <span className="text-[21px] text-gray2-100 ml-auto truncate">
            {parent?.email || "-"}
          </span>
        </div>
      </header>
    </div>
  );
};
